import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, fade } from '@material-ui/core/styles';
import { Chip, Typography } from '@material-ui/core';
import { Cancel as CancelIcon } from '@material-ui/icons';
import { PRESET_SCADENZA } from './scadenzaDocumento';

// The active chip takes the brand tint the section uses for its selected states
// (the reparto chips, the sort menu), with the brand's darker shade as text so
// that it reads on the tint; the others stay outlined and quiet.
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  etichetta: {
    color: theme.palette.text.secondary,
    fontSize: '0.8125rem',
    fontWeight: 600,
    marginRight: theme.spacing(0.5),
  },
  chip: {
    fontWeight: 500,
  },
  attivo: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    color: theme.palette.primary.dark,
    fontWeight: 600,
    '&:hover, &:focus': {
      backgroundColor: fade(theme.palette.primary.main, 0.18),
    },
  },
  rimuovi: {
    color: theme.palette.primary.dark,
  },
}));

/**
 * The expiry presets as exclusive chips: one at most is active, a click on the
 * active one takes it off, and so does its cross. The active chip also says how
 * many documents it found, once the list has arrived (`conteggio` is `null`
 * until then).
 */
export default function PresetScadenzaChips({ valore, conteggio, onChange }) {
  const classes = useStyles();

  return (
    <div className={classes.root} role="group" aria-label="Filtra per scadenza">
      <Typography component="span" className={classes.etichetta}>
        Scadenza
      </Typography>
      {PRESET_SCADENZA.map((preset) => {
        const attivo = preset.valore === valore;
        const label =
          attivo && conteggio != null
            ? `${preset.etichetta} · ${conteggio}`
            : preset.etichetta;
        return (
          <Chip
            key={preset.valore}
            label={label}
            clickable
            size="small"
            variant={attivo ? 'default' : 'outlined'}
            aria-pressed={attivo}
            className={`${classes.chip} ${attivo ? classes.attivo : ''}`}
            onClick={() => onChange(attivo ? null : preset.valore)}
            onDelete={attivo ? () => onChange(null) : undefined}
            deleteIcon={
              attivo ? (
                <CancelIcon
                  className={classes.rimuovi}
                  titleAccess={`Rimuovi il filtro ${preset.etichetta}`}
                />
              ) : undefined
            }
          />
        );
      })}
    </div>
  );
}

PresetScadenzaChips.propTypes = {
  valore: PropTypes.oneOf(PRESET_SCADENZA.map((preset) => preset.valore)),
  conteggio: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

PresetScadenzaChips.defaultProps = {
  valore: null,
  conteggio: null,
};
